import React from "react"
import HeadingL from "../../components/shared/HeadingL"
import Layout from "../../components/sutea/Layout"
import ProgramActivityExample from "../../components/sutea/ProgramActivityExample"
import ProgramSchedule from "../../components/sutea/ProgramSchedule"
import SEO from "../../components/Seo"
import { PAGE } from "../../constants"

const program = () => {
  return (
    <Layout>
      <SEO title={PAGE.title.program} siteTitle="すてあ" />
      <HeadingL title={PAGE.title.program} target="sutea" />
      <ProgramSchedule />
      <ProgramActivityExample />
    </Layout>
  )
}

export default program
